/* @flow */
import React from 'react';
// $FlowIgnore
import { GoBook } from 'react-icons/go';

export default function ReviewIcon({
  style
}: Object): React.Element {
  return <GoBook style={style} />;
}
